import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getProjectDomainTableColumn,
  getApplicationScopeTableColumn,
} from '@/utils/common/tableColumn'

export default {
  data () {
    return {
      columns: [
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          hideField: true,
          formRules: [{ required: true, message: this.$t('common.tips.input', [this.$t('table.title.name')]) }],
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
            )
          },
        }),
        getEnabledTableColumn(),
        getProjectDomainTableColumn({ vm: this }),
        getApplicationScopeTableColumn({
          vm: this,
          resource: `${this.wholeType}_reports`,
          scope: 'domain',
        }),
        {
          field: 'role',
          title: this.$t('report.notification_role'),
        },
        {
          field: 'report_type',
          title: this.$t(`report.${this.wholeType}_report_type`),
          formatter: ({ row }) => {
            if (row.id.includes('system')) return this.$t('report.month_report_type.system')
            if (row.id.includes('domain')) return this.$t('report.month_report_type.domain')
            if (row.id.includes('project')) return this.$t('report.month_report_type.project')
            if (row.templates || row.css || row.type) return this.$t('report.monitor_daily_report')
            return '-'
          },
        },
        {
          field: 'frequency',
          title: this.$t('report.alert_frequency'),
          formatter: ({ row }) => {
            const { day, hour, minute } = row
            if (this.wholeType === 'month') {
              return this.$t('report.month_report_frequency', [day, String(hour).padStart(2, '0'), String(minute).padStart(2, '0')])
            }
            return this.$t('report.daily_report_frequency', [String(hour).padStart(2, '0'), String(minute).padStart(2, '0')])
          },
        },
      ],
    }
  },
  methods: {
  },
}
